// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xe_a bhc_uj bhc_ua bhc_vx bhc_qk bhc_sl bhc_qb"};